<template>
  <div class="register">
    <div class="header">
      <div class="headerleft">
        <img :src="$headLogo" alt="$headLogo" :onerror="`this.src='${$defaultHeadLogo}'`">
      </div>
      <div class="headerright">
      </div>
    </div>
    <div class="content">
      <div class="main">
        <div style="width:1117px;height:559px;background:#ffffffbf;0;border-radius: 8px;" class="box">
          <div>
            <div style="margin:0 auto;padding-top:58px;height:32px;">
              <steps ref="stepsChild" :key="stepsIndex" :width="width"></steps>
            </div>
            <div class="tjform">
              <el-form v-show="stepsIndex == 0" ref="loginForm1" :model="loginForm1" label-position="left"
                label-width="0px" class="demo-ruleForm register-page">
                <el-form-item :rules="[
                  {
                    required: true,
                    validator: validatephone1,
                    trigger: 'change',
                  },
                ]" prop="phone" style="margin-bottom: 0px">
                  <el-input v-model="loginForm1.phone" type="text" auto-complete="off" placeholder="请输入手机号"
                    @input="ddd"></el-input>
                </el-form-item>
                <el-form-item :rules="[
                  {
                    required: true,
                    message: '请输入短信验证码',
                    trigger: 'change',
                  },
                ]" prop="verifyCode" style="margin-top: 59px;margin-bottom: 0px" class="Sphone_code">
                  <el-input v-model="loginForm1.verifyCode" type="text" auto-complete="off" placeholder="请输入短信验证码">
                    <p v-if="!time" slot="suffix" style="color:#1E6EF5;height:45px;line-height:45px;cursor: pointer;"
                      @click="getverificationcode">
                      <el-popover v-model="visible" :disabled="disabled" placement="top-end" popper-class="popperverifyPassWord"
                        width="400" trigger="manual">
                        <div style="margin:10px 10px 15px 10px;">
                          <div style="margin-bottom:8px">
                            <span style="color:#333;font-size:12px;margin-right:361px;cursor: default;">完成拼图验证</span>
                            <span style="color:var(--theme-color);margin-right:35px;cursor: pointer;" @click="shuaxin">
                              <i class="el-icon-refresh">换一张</i>
                            </span>
                            <span style="color:#BDC8D9;cursor: pointer;">
                              <i class="el-icon-close" @click="close"></i>
                            </span>
                          </div>
                          <slideverify ref="verify" :w="530" @success="success" @fail="fail"></slideverify>
                        </div>
                        <p slot="reference" @click="onvisible">
                          获取验证码
                        </p>
                      </el-popover>
                    </p>
                    <p v-if="time" slot="suffix" style="color:##1E6EF5;height:45px;line-height:45px;">
                      {{ time }}秒后可重新获取
                    </p>
                  </el-input>
                </el-form-item>
                <el-form-item style="width: 100%;margin-bottom: 0px;margin-top: 56px">
                  <el-button :loading="logining" type="primary" class="stepNext" @click="handleRegister('loginForm1')">
                    下一步
                  </el-button>
                </el-form-item>
                <p style="float: right;margin-top: 18px" @click="gplogin">
                  <span style="font-size:14px;color:#333;cursor: pointer;">已想起密码?</span>
                  <span style="font-size:14px;color:#1E6EF5;cursor: pointer;">返回登录></span>
                </p>
              </el-form>
              <el-form v-show="stepsIndex == 1" ref="loginForm2" :model="loginForm2" label-position="left"
                label-width="0px" class="demo-ruleForm register-page">
                <p style="color:#000;font-size:16px">
                  为确认是您本人操作，请输入您的姓名完成身份验证：
                </p>
                <el-form-item :rules="[
                  {
                    required: true,
                    message: '请输入姓名',
                    trigger: 'change',
                  },
                ]" prop="name" style="margin-top: 35px;margin-bottom: 0px">
                  <el-input v-model="loginForm2.name" type="text" auto-complete="off" placeholder="请输入姓名" maxlength="10"
                    minlength="1"></el-input>
                </el-form-item>
                <el-form-item style="width: 100%;margin-bottom: 0px;margin-top: 39px;">
                  <el-button :loading="logining2" type="primary" class="stepNext"
                    @click="handleRegister2('loginForm2')">
                    下一步
                  </el-button>
                </el-form-item>
                <p style="float: right;margin-top: 18px" @click="gplogin">
                  <span style="font-size:14px;color:#333;cursor: pointer;">已想起密码?</span>
                  <span style="font-size:14px;color:#1E6EF5;cursor: pointer;">返回登录></span>
                </p>
              </el-form>
              <el-form v-show="stepsIndex == 2" ref="loginForm3" :model="loginForm3" :rules="rules3"
                label-position="left" label-width="0px" class="demo-ruleForm register-page">
                <el-form-item prop="password1" style="margin-bottom: 0px">
                  <el-input style="position:fixed;top:-9999px;" type="text"></el-input>
                  <el-input v-model.trim="loginForm3.password1" :type="passwordType1" auto-complete="new-password"
                    placeholder="请设置8-20位登录密码,至少包含大写字母、小写字母、数字、特殊符号四种类型" @keydown.native="keydown($event)"
                    @input="inputMethod">
                    <p v-if="passwordType1 == 'text' && loginForm3.password1" slot="suffix" class="bukejin"
                      @click="showPwd1"></p>
                    <p v-if="passwordType1 == 'password' && loginForm3.password1" slot="suffix" class="nobukejin"
                      @click="showPwd1"></p>
                  </el-input>
                  <p v-if="noteshow" style="position: absolute;top:54px;font-size:12px">
                    <span style="color:#e6a23c;">{{ str2 }}</span>
                  </p>
                </el-form-item>
                <el-form-item prop="password2" style="margin-top: 59px;margin-bottom: 0px">
                  <el-input v-model.trim="loginForm3.password2" :type="passwordType2" auto-complete="new-password"
                    placeholder="请再次输入密码" @input="changeInputValue2()" @keydown.native="keydown($event)">
                    <p v-if="passwordType2 == 'text' && loginForm3.password2" slot="suffix" class="bukejin"
                      @click="showPwd2"></p>
                    <p v-if="passwordType2 == 'password' && loginForm3.password2" slot="suffix" class="nobukejin"
                      @click="showPwd2"></p>
                  </el-input>
                </el-form-item>
                <el-form-item style="width: 100%;margin-bottom: 0px;margin-top: 59px;">
                  <el-button :logining="logining3" type="primary" class="stepNext"
                    @click="handleRegister3('loginForm3')">
                    重置密码
                  </el-button>
                </el-form-item>
                <p style="float: right;margin-top: 18px" @click="gplogin">
                  <span style="font-size:14px;color:#333;cursor: pointer;">已想起密码?</span>
                  <span style="font-size:14px;color:#1E6EF5;cursor: pointer;">返回登录></span>
                </p>
              </el-form>
              <el-form v-show="stepsIndex == 3" label-position="left" label-width="0px"
                class="demo-ruleForm register-page">
                <div style="text-align: center;margin-top:18px">
                  <img :src="zhuce" alt="" />
                </div>
                <div style="font-size:26px;text-align: center;">
                  密码已重置成功!!!
                </div>
                <div style="color:var(--theme-color);font-size:14px;text-align: center;margin-top:8px">
                  快去登录吧~
                </div>
                <div style="margin:0 auto;text-align: center;margin-top:16px;">
                  <el-button type="primary" class="stepNext" @click="gplogin">
                    去登录
                  </el-button>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 插件端下载 -->
    <app-download v-if="appDownloadShow" ref="appDownload" :plug-form="plugForm" :app-form="appForm" />
  </div>
</template>
<script>
import slideverify from "@/CommonDP/components/monoplastyslideverify/index";
import steps from "@/CommonDP/components/steps";
import registerService from "@/CommonDP/service/register-service";
import enterpriseService from "@/CommonDP/service/enterprise-service";
import { storage } from "@/CommonDP/utils";
import appDownload from "@/CommonDP/components/appDownload/index.vue";
export default {
  name: "Register",
  components: {
    steps,
    slideverify,
    appDownload
  },
  data() {
    var validatePass = (rule, value, callback) => {
      var idCardx = /[\u4e00-\u9fa5]/;
      var mediumRegex = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
      if (value === "") {
        this.noteshow = false;
        callback(new Error("请输入密码"));
      } else if (idCardx.test(value)) {
        this.noteshow = false;
        callback(new Error("密码不允许中文"));
      } else if (value.length < 8 || value.length > 20) {
        this.noteshow = false;
        callback(new Error("密码长度为8~20个字符"));
      } else if (!mediumRegex.test(value)) {
        this.noteshow = false;
        callback(new Error("请至少使用大写字母、小写字母、数字、特殊符号四种类型组合的密码"));
      } else {
        if (this.loginForm3.password2 !== "") {
          this.$refs.loginForm3.validateField("password2");
        }
        this.noteshow = true;
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.loginForm3.password1) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      stepsIndex: 0,
      stepsData: [{ name: "验证手机号" }, { name: "验证身份" }, { name: "重置密码" }, { name: "重置成功" }],
      loginForm1: {
        phone: "",
        verifyCode: ""
      },
      loginForm2: {
        name: ""
      },
      time: "",
      disabled: true,
      visible: false,
      repeat1: "",
      repeat2: "",
      repeat3: "",
      dd: false,
      passwordType1: "text",
      passwordType2: "text",
      zhuce: require("@/CommonDP/assets/enterprise/支付成功 (1).png"),
      logining: false,
      logining2: false,
      rules3: {
        password1: [{ required: true, validator: validatePass, trigger: "change" }],
        password2: [{ required: true, validator: validatePass2, trigger: "change" }]
      },
      loginForm3: {
        password1: "",
        password2: ""
      },
      logining3: false,
      str2: "",
      noteshow: false,
      width: "270",
      plugForm: {
        createTime: "",
        filePath: ""
      },
      appForm: {
        createTime: "",
        filePath: ""
      },
      appDownloadShow: false
    };
  },

  created() {
    this.stepsIndex = storage.get("stepsIndex2");
  },
  methods: {
    // 帮助手册提示
    manualHelpBtn() {
      this.$message.warning("请登录后再进行帮助手册的查看与下载操作");
    },
    async plugBtn() {
      const res = await enterpriseService.getPlugList();
      if (res.data && res.data.length > 0) {
        res.data.forEach((item) => {
          if (item.fileType === 15 || item.fileType === 17) {
            const a = item.createTime.split(" ")[0];
            this.plugForm.createTime = a.replace(/-/g, "/");
            this.plugForm.filePath = item.filePath;
          }
          if (item.fileType === 10) {
            const a = item.createTime.split(" ")[0];
            this.appForm.createTime = a.replace(/-/g, "/");
            this.appForm.filePath = item.filePath;
          }
        });
      }
      this.appDownloadShow = true;
      this.$nextTick(() => {
        this.$refs.appDownload.showDialog();
      });
    },
    inputMethod(value) {
      if (!this.loginForm3.password1) {
        this.passwordType1 = "text";
      } else {
        this.passwordType1 = "password";
      }
      var strongRegex = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
      var mediumRegex = new RegExp(
        "^(((?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[a-z])(?=.*\\W))|((?=.*[A-Z])(?=.*[0-9])(?=.*\\W))|((?=.*[a-z])(?=.*[0-9])(?=.*\\W))).*$",
        "g"
      );
      var enoughRegex = new RegExp(
        "^(((?=.*[A-Z])|(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[a-z])(?=.*\\W))|((?=.*[0-9])(?=.*\\W))|((?=.*[A-Z])(?=.*\\W))).*$",
        "g"
      );
      if (strongRegex.test(value)) {
        this.str2 = "当前密码强度：强";
      } else if (mediumRegex.test(value)) {
        this.str2 = "当前密码强度：中等";
      } else if (enoughRegex.test(value)) {
        this.str2 = "当前密码强度：弱";
      }
    },
    showPwd1() {
      if (this.passwordType1 === "password") {
        this.passwordType1 = "text";
      } else {
        this.passwordType1 = "password";
      }
    },
    showPwd2() {
      if (this.passwordType2 === "password") {
        this.passwordType2 = "text";
      } else {
        this.passwordType2 = "password";
      }
    },
    keydown(event) {
      if (event.keyCode === 32) {
        event.returnValue = false;
      }
    },
    changeInputValue2() {
      if (!this.loginForm3.password2) {
        this.passwordType2 = "text";
      } else {
        this.passwordType2 = "password";
      }
    },
    ddd() {
      this.dd = false;
    },
    validatephone1(rule, value, callback) {
      var idCardx = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      this.disabled = true;
      this.repeat1 = callback;
      this.repeat2 = value;
      this.repeat3 = rule;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (this.loginForm1.phone.length > 11) {
        callback(new Error("手机号码不得超过11位"));
      } else if (!idCardx.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else if (this.dd) {
        this.visible = false;
        callback(new Error("该手机号未注册"));
      } else {
        this.disabled = false;
        callback();
      }
    },
    handleRegister(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          var params = {
            phone: this.loginForm1.phone,
            verifyCode: this.loginForm1.verifyCode,
            smsTemplateId: "1094812"
          };
          registerService
            .smscheckVerifyCode(params)
            .then((res) => {
              if (res.result === "0" && res.data) {
                var params1 = {
                  phone: this.loginForm1.phone,
                  verifyCode: this.loginForm1.verifyCode,
                  name: "",
                  uuid: res.data
                };
                storage.set("loginFormz2", JSON.stringify(params1));
                var data = { phone: this.loginForm1.phone };
                // 调接口判断是否有姓名 有名字stepsIndex是1 没有名字是 stepsIndex是2
                registerService
                  .userexists(data)
                  .then((res) => {
                    this.logining = false;
                    if (res.data === 1) {
                      this.stepsIndex = 1;
                      storage.set("stepsIndex2", 1);
                    } else if (res.data === 2) {
                      this.stepsIndex = 2;
                      storage.set("stepsIndex2", 2);
                    }
                  })
                  .catch(() => {
                    this.logining = false;
                  });
              }
            })
            .catch(() => {
              this.logining = false;
            });
        } else {
          return false;
        }
      });
    },
    handleRegister2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 验证输入的名字与已经存在的名字是否一致
          var data = {
            phone: JSON.parse(storage.get("loginFormz2")).phone,
            name: this.loginForm2.name,
            verifyCode: JSON.parse(storage.get("loginFormz2")).verifyCode,
            uuid: JSON.parse(storage.get("loginFormz2")).uuid
          };
          var params = {
            phone: JSON.parse(storage.get("loginFormz2")).phone,
            verifyCode: JSON.parse(storage.get("loginFormz2")).verifyCode,
            name: this.loginForm2.name,
            uuid: JSON.parse(storage.get("loginFormz2")).uuid
          };
          storage.set("loginFormz2", JSON.stringify(params));
          this.logining2 = true;
          registerService
            .userverifyName(data)
            .then((res) => {
              this.logining2 = false;
              if (res.result === "0") {
                if (res.data) {
                  this.stepsIndex = 2;
                  storage.set("stepsIndex2", 2);
                } else {
                  this.$message.warning("身份验证失败，请重新输入");
                }
              }
            })
            .catch(() => {
              this.logining2 = false;
            });
        } else {
          return false;
        }
      });
    },
    handleRegister3(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = {
            phone: "",
            verifyCode: "",
            name: "",
            password: "",
            uuid: ""
          };
          if (JSON.parse(storage.get("loginFormz2")).name) {
            params = {
              phone: JSON.parse(storage.get("loginFormz2")).phone,
              verifyCode: JSON.parse(storage.get("loginFormz2")).verifyCode,
              name: JSON.parse(storage.get("loginFormz2")).name,
              password: this.loginForm3.password1,
              uuid: JSON.parse(storage.get("loginFormz2")).uuid
            };
          } else {
            params = {
              phone: JSON.parse(storage.get("loginFormz2")).phone,
              verifyCode: JSON.parse(storage.get("loginFormz2")).verifyCode,
              password: this.loginForm3.password1,
              uuid: JSON.parse(storage.get("loginFormz2")).uuid
            };
          }
          this.logining3 = true;
          registerService
            .userresetPassword(params)
            .then((res) => {
              if (res.result === "0") {
                this.stepsIndex = 3;
                storage.set("stepsIndex2", 3);
                this.logining3 = false;
              }
            })
            .catch(() => {
              this.logining3 = false;
            });
        } else {
          return false;
        }
      });
    },
    onvisible() {
      this.$refs.verify.refresh();
      if (this.disabled) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    shuaxin() {
      this.$refs.verify.refresh();
    },
    getverificationcode() {
      if (!this.loginForm1.phone) {
        this.$refs.loginForm1.validateField("phone");
      }
    },
    gplogin() {
      if (this.$route.query.code) {
        var code = this.$route.query.code;
        this.$router.replace({ path: "/login", query: { code: code }});
      } else {
        this.$router.push({ name: "login" });
      }
    },
    close() {
      this.visible = false;
    },
    success() {
      var encoded = encodeURI(this.repeat2);
      var params = { phone: encoded };
      registerService
        .userexists(params)
        .then((res) => {
          if (res.data !== 0) {
            this.dd = false;
            this.$refs.loginForm1.validateField("phone");
            // 开始发起验证码
            var params = {
              phone: this.loginForm1.phone,
              smsTemplateId: "1094812"
            };
            registerService
              .smssendVerifyCode(params)
              .then((res) => {
                if (res.result === "0") {
                  this.time = 60;
                  this.visible = false;
                  this.$message.success("验证通过!");
                  this.flushTime();
                }
              })
              .catch(() => {});
          } else {
            this.dd = true;
            this.$refs.loginForm1.validateField("phone");
          }
        })
        .catch(() => {});
    },
    flushTime() {
      const that = this;
      const intval = setInterval(function () {
        that.time--;
        if (that.time < 1) {
          that.time = 0;
          clearInterval(intval);
        }
      }, 1000);
    },
    fail() {}
  }
};
</script>
<style lang="scss" scoped>
.register {
  min-width: 1120px;
  width: 100%;
  min-height: 800px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    line-height: 68px;
    overflow: hidden;
    position: absolute;
    top: 0;
    text-align: center;
    box-sizing: border-box;
    .headerleft {
      float: left;
      display: flex;
      align-items: center;
      min-height: 40px;
      padding: 10px;
      box-sizing: border-box;
    }
    .headerright {
      float: right;
      span {
        margin-right: 53px;
        font-size: 14px;
        color: #000;
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }
  .content {
    position: absolute !important;
    position: relative;
    top: 68px !important;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    min-height: 1000px;
    overflow-y: auto;
    background: url("../../assets/enterprise/qiye.png") no-repeat;
    .box {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      .tjform {
        width: 550px;
        margin: 0 auto;
        margin-top: 100px;
        .el-input {
          width: 550px;
        }
        /deep/ .el-form-item {
          margin-bottom: 0px;
          .el-input__inner {
            background: #e8f0fe;
            border-color: #fff;
            border-radius: 2px;
            color: #6681a0;
            height: 46px;
          }
          .el-input__inner:focus {
            border-color: #1e6ef5;
          }
          .el-button--primary {
            background: #72a6fe !important;
          }
          .el-button--primary:hover {
            background: var(--theme-color) !important;
          }
          .el-form-item__content {
            line-height: 0px;
          }
        }
        .Sphone_code {
          /deep/ .el-input__suffix {
            right: 15px;
          }
        }
        .bukejin {
          width: 20px;
          height: 16px;
          background: url("../../assets/可见.png") no-repeat;
          background-size: 100% 100%;
          background-position: center center;
          margin-top: 15px;
          margin-right: 15px;
        }
        .nobukejin {
          width: 20px;
          height: 16px;
          background: url("../../assets/不可见.png") no-repeat;
          background-size: 100% 100%;
          background-position: center center;
          margin-top: 15px;
          margin-right: 15px;
        }
      }
    }
  }
}
.stepNext {
  width: 550px !important;
  height: 46px !important;
  border-radius: 2px !important;
  border: none !important;
}
</style>
<style>
.popperverifyPassWord {
  width: 550px !important;
  left: 686px !important;
  top: 205px !important;
  padding: 0px !important;
}
.popperverifyPassWord .popper__arrow {
  left: 496.5px !important;
}
</style>
